import { initializeApp } from 'firebase/app';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';

// Initialize Firebase
const app = initializeApp({
  apiKey: 'AIzaSyD_NEVbgKv9wSOc8DmhtW8Fni3t1MDlcPw',
  authDomain: 'algodoor.firebaseapp.com',
  projectId: 'algodoor',
  storageBucket: 'algodoor.appspot.com',
  messagingSenderId: '589970255668',
  appId: '1:589970255668:web:3c5a4c5d828207973dbf61',
  measurementId: 'G-DZ7GQRVKV9',
});

// Firebase storage reference
const storage = getStorage(app);
const db = getFirestore(app);

export { app, db };
export default storage;
